import { getLookupRecord, readField } from '../api';
import { toLookupOption } from '../components/lookupOption';
import { isUomGuid } from './baseUomOptions';

export const resolveUomReferences = async (rows, signal) => {
    const records = new Map(rows.map(row => [`units-of-measurement:${row.id}`, row]));
    const requests = new Map();
    for (const row of rows) {
        for (const [entity, id] of [['commodities', row.commodityId], ['dimensions', row.dimensionId], ['units-of-measurement', row.baseUoMId]]) {
            const key = `${entity}:${id}`;
            if (isUomGuid(id) && !records.has(key) && !requests.has(key)) {
                requests.set(key, getLookupRecord(entity, id, signal));
            }
        }
    }
    const results = await Promise.allSettled(requests.values());
    [...requests.keys()].forEach((key, index) => {
        if (results[index].status === 'fulfilled') records.set(key, results[index].value);
    });
    return {
        failed: results.some(result => result.status === 'rejected'),
        rows: rows.map(row => {
            const commodity = records.get(`commodities:${row.commodityId}`);
            const dimension = records.get(`dimensions:${row.dimensionId}`);
            const base = records.get(`units-of-measurement:${row.baseUoMId}`);
            return {
                ...row,
                commodity: commodity && Object.fromEntries(['name', 'abbreviation', 'commodityIcon', 'commodityColor'].map(key => [key, readField(commodity, key)])),
                dimensionName: readField(dimension, 'name') || row.dimensionName,
                baseUoMName: base ? toLookupOption(base).label : row.baseUoMName,
            };
        }),
    };
};
